import { InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { useField } from "@unform/core";
import { useEffect, useState } from "react";

type TVTextFieldProps = TextFieldProps & {
	name: string;
	trimEmptySpaces?: boolean;
};

export const VTextField: React.FC<TVTextFieldProps> = ({ name, trimEmptySpaces, ...rest }) => {
	const { fieldName, registerField, defaultValue, error, clearError } = useField(name);

	// ✅ sempre inicializa com string vazia, nunca undefined
	const [value, setValue] = useState(defaultValue ?? "");

	useEffect(() => {
		registerField({
			name: fieldName,
			getValue: () => value,
			setValue: (_, newValue) => setValue(newValue ?? ""),
			clearValue: () => setValue(""),
		});
	}, [registerField, fieldName, value]);

	return (
		<TextField
			{...rest}
			error={!!error}
			helperText={error}
			// ❌ REMOVIDO: defaultValue (era causa do warning)
			value={value ?? ""}
			onChange={(e) => {
				const inputValue = e.target.value;
				const consideredValue = trimEmptySpaces ? inputValue.replace(/( )/g, "") : inputValue;
				setValue(consideredValue);
				rest.onChange?.(e);
			}}
			onKeyDown={(e) => {
				if (error) clearError();
				rest.onKeyDown?.(e);
			}}
			size="small"
			InputProps={{
				startAdornment: <InputAdornment position="start"></InputAdornment>,
			}}
		/>
	);
};
